exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".textarea-style {\n  border: 1px solid #ccc;\n  width: 100%;\n  height: 70px;\n  background: #f1f1f1 !important;\n  border-radius: 5px;\n}\n.input-card {\n  border: 1px solid #ccc;\n  text-align: center;\n  width: 100%;\n  height: 28px;\n}\n.backg-red {\n  background: #f00 !important;\n  border-color: #f00;\n}\n.bloq-bton {\n  pointer-events: none !important;\n}\n", ""]);

// exports
